import {Component, OnDestroy, OnInit} from '@angular/core';
import { CommonModule } from '@angular/common';
import {IDialogComponent} from "../../../../../../../common/dialog/iDialog.component";
import {DialogWithInput} from "../../../../../../../common/dialog/dialogWithInput";
import {
  PaymentRequestOnlineAttemptRefreshStatusActionService
} from "../../service/paymentRequestOnlineAttemptRefreshStatusAction.service";
import {DialogModule} from "../../../../../../../common/dialog/dialog.module";
import {CardModule} from "../../../../../../../core/component/card/card.module";
import {LoadingModule} from "../../../../../../../../components/common/loading/loading.module";
import {FormFieldModule} from "../../../../../../../core/component/form-field/form-field.module";
import {
  PriceSummaryFieldModule
} from "../../../../../../../common/price/api/component/price-summary-field/price-summary-field.module";
import {PriceLabelModule} from "../../../../../../../common/price/api/component/price-label/price-label.module";
import {TablerIconsModule} from "angular-tabler-icons";
import {
  PaymentRequestOnlineAttemptStatus,
  PaymentRequestOnlineAttemptSummaryModel
} from "../../entity/paymentRequestOnlineAttemptSummary.model";
import {ErrorTextModule} from "../../../../../../../core/component/error-text/error-text.module";
import {PaymentRequestOnlineAttemptModel} from "../../entity/paymentRequestOnlineAttempt.model";
import {PaymentRequestRepository} from "../../../../impl/service/ngrx/PaymentRequest.repository";
import {SaleRepository} from "../../../../../../impl/service/ngrx/Sale.repository";

export interface PaymentRequestOnlineAttemptCardInProgressDialogInput {
  paymentRequestAttemptId: number;
}

@Component({
  standalone: true,
  imports: [CommonModule, DialogModule, CardModule, LoadingModule, FormFieldModule, PriceSummaryFieldModule, PriceLabelModule, TablerIconsModule, ErrorTextModule],
  templateUrl: './payment-request-online-attempt-card-in-progress-dialog.component.html',
  providers: [
    PaymentRequestOnlineAttemptRefreshStatusActionService
  ]
})
export class PaymentRequestOnlineAttemptCardInProgressDialogComponent implements
    IDialogComponent<PaymentRequestOnlineAttemptCardInProgressDialogInput, void>,
    OnInit,
    OnDestroy{
  dialog: DialogWithInput<PaymentRequestOnlineAttemptCardInProgressDialogInput, void>;
  interval: any;
  PaymentRequestOnlineAttemptStatus = PaymentRequestOnlineAttemptStatus;
  result: PaymentRequestOnlineAttemptModel;

  constructor(public actionService: PaymentRequestOnlineAttemptRefreshStatusActionService,
              private paymentRequestRepository: PaymentRequestRepository,
              private saleRepository: SaleRepository) {
  }

  ngOnInit(): void {
    this.interval = setInterval(() => this.executeAction(), 5000);
    this.executeAction();
  }

  ngOnDestroy() {
    this.clearInterval();
  }

  clearInterval() {
    if (this.interval) {
      clearInterval(this.interval);
      this.interval = 0;
    }
  }

  executeAction() {
    this.actionService.executeAction({
      id: this.dialog.input.paymentRequestAttemptId
    })
        .then(result => {
          if (result.summary.status?.value !== PaymentRequestOnlineAttemptStatus.PAYMENT_ONLINE_STATUS_CREATED) {
            this.clearInterval();
          }
          if (result.summary.status?.value === PaymentRequestOnlineAttemptStatus.PAYMENT_ONLINE_STATUS_SUCCESSFUL) {
            this.paymentRequestRepository.clearCache();
            this.saleRepository.clearCache();
          }
            this.result = result;
        })

        .catch(() => this.clearInterval());
  }
}